import { Component, HostBinding, Input, inject } from '@angular/core';

import { SecondaryNavGroup } from '@hdms/shared/page-frame/types';
import { FeatureToggleService } from '@hdms/shared/util-core';

@Component({
  selector: 'shrd-pf-ui-editorial-menu-links',
  templateUrl: './header-editorial-menu-links.component.html',
  styleUrls: ['./header-editorial-menu-links.component.scss']
})
export class HeaderEditorialMenuLinksComponent {
  @HostBinding('class.content-box')
  @Input()
  inFlyout = false;

  @Input() menuItems: SecondaryNavGroup[];

  @Input() menuTitle?: string;

  readonly enableThumbnail = inject(FeatureToggleService).getToggleById('ldt_hdms_header_editorial_nav_image');
}
